import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useId, forwardRef, createRef, useImperativeHandle, useState, useEffect } from "react";
import { Container } from "./Container";
import { WithModalContext } from "./Context";
;
const withModal = (WrappedComponent, config) => {
    const currentRef = createRef();
    const show = () => {
        currentRef.current?.show();
    };
    const showPopup = (event) => {
        currentRef.current?.showPopup(event);
    };
    const hide = () => {
        currentRef.current?.hide();
    };
    const setState = (data) => {
        if (typeof currentRef.current.setState !== 'function')
            return;
        currentRef.current.setState(data);
    };
    return {
        ...forwardRef((props, ref) => {
            const modalRef = useRef(null);
            const [stateData, setStateData] = useState();
            const id = useId();
            const [currentConfig, _setConfig] = useState(config);
            const setConfig = (config) => {
                _setConfig((currentConfig) => ({
                    ...currentConfig,
                    ...config
                }));
            };
            useEffect(() => {
                _setConfig(config);
            }, [config]);
            useImperativeHandle(currentRef, () => ({
                ...modalRef.current,
                setState: setStateData
            }));
            return (_jsx(WithModalContext.Provider, { value: {
                    setConfig,
                    state: stateData,
                    footerRef: modalRef.current?.footerRef,
                    showPopup,
                    show,
                    hide,
                    withModal: true
                }, children: _jsx(Container, { name: currentConfig?.name ?? id, title: currentConfig?.title ?? '', ...currentConfig, ref: modalRef, children: _jsx(WrappedComponent, { ...props, ref: ref }) }) }));
        }),
        showPopup,
        show,
        hide,
        setState
    };
};
export { withModal };
